<script setup lang="ts">
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import Email from '@/pages/(home)/account/content/email.vue';

definePage({ name: 'AccountEmail', meta: { title: 'account.tabs.email' } });
</script>

<template>  
  <h5>{{ $t('account.tabs.email') }}</h5>
  <Suspense>
    <Email />

    <template #fallback>
      <div>
        <BootstrapCard :shimmer="true" :shimmer-height="160" :header-text="$t('account.changeEmail')" class="mb-2" />
        <BootstrapCard :shimmer="true" :shimmer-height="75" :header-text="$t('account.emailStatus')" />
      </div>
    </template>
  </Suspense>
</template>

<style scoped>

</style>